import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { CheckoutDataService } from '@app/services';
import { RoutingConfigService } from 'haba-core';
import { CheckoutStepService } from 'haba-featurelibs/checkout/components';
import { CheckoutStepType } from 'haba-featurelibs/checkout/root';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class habaCheckoutBillingAddressGuard {
  constructor(
    private checkoutDataService: CheckoutDataService,
    private routingConfigService: RoutingConfigService,
    private checkoutStepService: CheckoutStepService,
    private router: Router
  ) {}

  canActivate(): Observable<true | UrlTree> {
    return this.checkoutDataService.getCheckoutData().pipe(
      map((checkoutData) => {
        if (
          !this.checkoutDataService.isBillingAddressValid(checkoutData?.paymentAddress) ||
          !this.checkoutDataService.isShippingAddressValid(checkoutData?.deliveryAddress)
        )
          return true;
        return this.getRoute();
      })
    );
  }

  getRoute(): UrlTree {
    return this.router.parseUrl(
      this.routingConfigService.getRouteConfig(
        this.checkoutStepService.getCheckoutStepRoute(CheckoutStepType.REVIEW_ORDER)
      ).paths?.[0] as string
    );
  }
}
